<div class="container qai-auth-container d-flex align-items-center justify-content-center">
    <div class="card p-4 shadow" style="max-width: 620px;">
        <div class="card-body p-5 pt-2 pb-2">
            <h3 class="card-title mt-5 text-center fw-bold" i18n>
                @if (expiredPassword()) {
                Password Scaduta
                } @else if (!oobCode()) {
                Modifica Password
                } @else {
                Crea Password
                }
            </h3>
            @if (loadingOobVerification) {
            <div class="alert alert-info mt-4" role="alert">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="ms-2" i18n>Verifica del link in corso...</span>
            </div>
            } @else if (oobCodeErrorMsg) {
            <div class="alert mt-4" role="alert" [class.alert-danger]="oobCodeNotValid === 'Deprecated'" [class.alert-success]="oobCodeNotValid === 'Resended'">
                {{ oobCodeErrorMsg }}
            </div>
            @if (oobCodeNotValid === 'Deprecated') {
            <div class="d-flex justify-content-center">
                <app-loading-button (click)="resendOobCode()" [loading]="loadingOobResend"i18n>
                    Inviami un nuovo link
                </app-loading-button>
            </div>
            }
            } @else {
            <h6 class="card-subtitle mb-5 text-center text-body-secondary">
                @if (expiredPassword()) {
                La password ha una validità di 3 mesi.<br />
                }
                Inserisci
                @if (requiredOldPassword) {
                la tua password attuale e
                }
                la nuova password.
            </h6>
            <form [formGroup]="passwordForm" (ngSubmit)="saveNewPassword()">
                @if (requiredOldPassword) {
                <div class="mb-4">
                    <app-password-input [control]="passwordForm.controls['oldPassword']" [showValidatorCSS]="true"
                        placeholder="Vecchia Password" id="oldPassword" />
                    @if ((oldPassword?.touched || oldPassword?.dirty) && oldPassword?.invalid) {
                    <div class="text-danger text-center pt-2">
                        @if (oldPassword?.errors?.['required']) {
                        <div i18n>Vecchia password obbligatoria.</div>
                        }
                    </div>
                    }
                </div>
                }

                <div class="mb-4">
                    <app-password-input [control]="passwordForm.controls['password']" [showValidatorCSS]="true"
                        placeholder="Nuova Password" id="password" />
                    @if ((password?.touched || password?.dirty) && password?.invalid) {
                    <div class="text-danger text-center py-2">
                        @if (password?.errors?.['required']) {
                        <div i18n>Password obbligatoria.</div>
                        }
                        @if (password?.errors?.['minlength']) {
                        <div i18n>La password deve essere lunga almeno 8 caratteri.</div>
                        }
                        @if (password?.errors?.['missingUppercase']) {
                        <div i18n>La password deve contenere almeno una lettera maiuscola.</div>
                        }
                        @if (password?.errors?.['missingLowercase']) {
                        <div i18n>La password deve contenere almeno una lettera minuscola.</div>
                        }
                        @if (password?.errors?.['missingNumber']) {
                        <div i18n>La password deve contenere almeno un numero.</div>
                        }
                        @if (password?.errors?.['missingSpecialChar']) {
                        <div i18n>La password deve contenere almeno un carattere speciale.</div>
                        }
                        @if (password?.errors?.['repeatedChar']) {
                        <div i18n>Non sono permesse lettere uguali consecutive.</div>
                        }
                        @if (password?.errors?.['qwertySequence']) {
                        <div i18n>Non sono permesse sequenze QWERTY di 4 o più caratteri.</div>
                        }
                        @if (password?.errors?.['containsAccentedChars']) {
                        <div i18n>Non sono ammesse lettere accentate.</div>
                        }
                        @if (password?.errors?.['invalidSpecialChar']) {
                        <div i18n>Sono presenti caratteri speciali non consentiti.</div>
                        }
                    </div>
                    }
                    <div class="form-text text-center" id="passwordHelp" i18n>
                        La password deve avere almeno 8 caratteri, contenere maiuscole e minuscole,
                        un numero e un carattere speciale(.,!/\-_&#64;$*|.%&=?^[];:&lt;&gt;).
                        <br /><br />
                        Sono vietate 3 lettere uguali consecutive e sequenze QWERTY di 4+ caratteri.
                    </div>
                </div>

                <div class="mb-4">
                    <app-password-input [control]="passwordForm.controls['confirmPassword']" [showValidatorCSS]="true"
                        placeholder="Conferma Password" id="confirmPassword" />
                    @if ((confirmPassword?.touched || confirmPassword?.dirty) && confirmPassword?.invalid) {
                    <div class="text-danger text-center pt-2">
                        @if (confirmPassword?.errors?.['required']) {
                        <div i18n>Conferma Password obbligatoria.</div>
                        }
                        @if (confirmPassword?.errors?.['mismatch']) {
                        <div i18n>La conferma della password deve corrispondere alla password.</div>
                        }
                    </div>
                    }
                </div>

                <div class="d-flex flex-row gap-2 justify-content-center align-items-center">
                    <button type="submit" class="btn btn-primary" [disabled]="passwordForm.invalid || loading">
                        @if (loading) {
                        <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                        <span class="ms-2" role="status" i18n>Caricamento...</span>
                        } @else {
                        <span i18n>Salva</span>
                        }
                    </button>
                    @if (forgotPassword() || expiredPassword()) {
                    <button type="button" class="btn btn-secondary" (click)="returnToOTP()" i18n>Indietro</button>
                    }
                </div>
            </form>
            }
        </div>
    </div>
</div>